import React from "react";
import { Globe, Printer, Puzzle, TabletSmartphone } from "lucide-react";
import { Translate } from "components/common/Translate/Translate";
import {
    Section8UseCaseScaffold,
    ISection8UseCase,
} from "components/features/CompressorCommon/Section8UseCaseScaffold";

const bestUseList: ISection8UseCase[] = [
    {
        title: "optimizing-web-graphics-heading",
        subTitle: "optimizing-web-graphics-sub-heading",
        icon: <Globe strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "streamlining-image-assets-heading",
        subTitle: "streamlining-image-assets-sub-heading",
        icon: <Puzzle />,
    },
    {
        title: "enhancing-digital-design-heading",
        subTitle: "enhancing-digital-design-sub-heading",
        icon: <TabletSmartphone />,
    },
    {
        title: "perfect-for-print-media-heading",
        subTitle: "perfect-for-print-media-sub-heading",
        icon: <Printer />,
    },
];
const BestUsageForPngCompressorSection = () => {
    return (
        <Section8UseCaseScaffold
            title={<Translate keyName="best-usage-online-tool-title" />}
            useCases={bestUseList}
        />
    );
};

export default BestUsageForPngCompressorSection;
